namespace GeniuzPOS.QRreport {
    export interface QRywcSpecPurTaxForm {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DocMonth: Serenity.LookupEditor;
        DocYear: Serenity.DateYearEditor;
        ShopId: Serenity.LookupEditor;
        pSequenFg: Serenity.RadioButtonEditor;
        PmType: Serenity.RadioButtonEditor;
    }

    export class QRywcSpecPurTaxForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpecPurTax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpecPurTaxForm.init)  {
                QRywcSpecPurTaxForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateYearEditor;
                var w4 = s.RadioButtonEditor;

                Q.initFormType(QRywcSpecPurTaxForm, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DocMonth', w0,
                    'DocYear', w3,
                    'ShopId', w0,
                    'pSequenFg', w4,
                    'PmType', w4
                ]);
            }
        }
    }
}
